exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".home-top h2 {\n  animation: fadein 3s;\n  -moz-animation: fadein 3s;\n  -webkit-animation: fadein 3s;\n  -o-animation: fadein 3s;\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n", ""]);

